<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import { createEventDispatcher } from 'svelte';
	import { twMerge } from 'tailwind-merge';
	import Cta from './Cta.svelte';
	import SegmentedInput from './SegmentedInput.svelte';

	export let verificationId: number | string;

	let code: string = '';
	let error: string | null = null;
	let success = false;
	let canSubmitVerification = false;
	let submitting = false;

	let className: string = '';
	export { className as class };

	$: {
		canSubmitVerification = code !== 'typing';
	}

	const dispatch = createEventDispatcher();

	async function submitVerification(event) {
		if (submitting) return;
		submitting = true;

		try {
			const body = new FormData(event.target);

			const response = await fetch(`/api/crm/leads/${verificationId}/verify/${code}`, {
				method: 'POST',
				body
			});

			const responseData = await response.json();
			submitting = false;

			console.log(responseData);
			if (!responseData.success) {
				error = responseData?.data?.data?.message;
				return;
			}

			dispatch('success');
		} catch (error) {
			submitting = false;
		}
	}
</script>

<form
	method="POST"
	on:submit|preventDefault={submitVerification}
	class={twMerge('mt-4', className)}
>
	<div class="text-center md:flex md:gap-12">
		<div class="group relative z-0 mb-10 mt-4 w-full">
			<SegmentedInput
				label={$__('Confirme o código recebido por SMS')}
				styleClass={'top-4'}
				length={4}
				bind:code
			/>
			<span class="text-red-500">{error || ''}</span>
			<input type="hidden" name="id" value={verificationId} />
			<input type="hidden" name="sms_code" value={code} />
			<Cta
				type="button"
				props={{ type: 'submit' }}
				class="mt-10 inline-block px-10 py-4 text-center font-semibold leading-nav-button text-white md:w-full md:border-0 lg:mt-12 2xl:text-nav-button {canSubmitVerification
					? 'bg-primary'
					: 'bg-contact-btn'}"
			>
				{$__('Validar')}
			</Cta>
		</div>
	</div>
</form>
